import React from 'react';
import { Flex, TextV2, LinkV2, IconV2 } from '@withjoy/joykit';
import { PriceMatchPromise } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import { useEventTypeConfig } from '@shared/utils/eventType';
import { styles } from './PriceMatchBanner.styles';

export const PriceMatchBanner: React.FC = () => {
  const { tq } = useTranslation('sharedRegistry');
  const { config } = useEventTypeConfig();

  return (
    <Flex __css={styles.container}>
      <IconV2 size={24}>
        <PriceMatchPromise />
      </IconV2>
      <Flex __css={styles.textColumn}>
        <TextV2
          typographyVariant="label1"
          fontWeight="semibold"
        >
          {tq`Price match promise`}
        </TextV2>
        <TextV2
          typographyVariant="label2"
          color="mono12"
        >
          {tq`Found it cheaper at a major retailer? We'll match it. Regular price only, within 48 hrs.`}
          {config?.registryPriceMatchHelpLink && (
            <>
              {' '}
              <LinkV2
                href={config.registryPriceMatchHelpLink}
                typographyVariant="label2"
                target="_blank"
                rel="noopener noreferrer"
              >
                {tq`See details`}
              </LinkV2>
            </>
          )}
        </TextV2>
      </Flex>
    </Flex>
  );
};
